.container {
  :global(.ant-dropdown-menu-title-content) {
    display: flex;
    justify-content: center;
  }
}
